const SECURE_KEY_CONFIG_ASCII = {
  dev: {
    keyId: [48, 73, 78, 76, 99, 111],
    salt: [
      66, 84, 72, 48, 49, 75, 80, 53, 90, 65, 77, 54, 77, 88, 49, 55, 56, 87, 69, 66, 55, 55, 53,
      82, 72, 90,
    ],
    privateKey: [114, 106, 55, 108, 50, 51, 100, 72, 120, 100, 84, 118, 86, 55, 49, 53],
    privateIv: [119, 90, 97, 122, 65, 111, 119, 97, 106, 81, 82, 79, 99, 51, 67, 97],
  },
  test: {
    keyId: [57, 105, 107, 54, 112, 122],
    salt: [
      70, 90, 87, 48, 49, 75, 80, 53, 90, 69, 56, 65, 66, 83, 86, 51, 77, 56, 68, 80, 80, 89, 77,
      72, 48, 55,
    ],
    privateKey: [78, 48, 103, 101, 49, 76, 89, 68, 85, 119, 102, 51, 84, 84, 53, 103],
    privateIv: [48, 71, 102, 69, 107, 105, 76, 97, 50, 53, 107, 107, 110, 104, 118, 48],
  },
  prep: {
    keyId: [83, 97, 109, 111, 117, 57],
    salt: [
      89, 88, 77, 48, 49, 75, 80, 53, 90, 72, 84, 49, 48, 70, 81, 49, 83, 87, 48, 52, 77, 71, 54,
      67, 50, 57,
    ],
    privateKey: [106, 81, 101, 88, 49, 51, 68, 104, 66, 75, 50, 120, 84, 106, 89, 115],
    privateIv: [109, 52, 100, 88, 75, 77, 49, 122, 53, 79, 76, 76, 105, 97, 56, 66],
  },
  prod: {
    keyId: [78, 69, 79, 110, 84, 111],
    salt: [
      88, 74, 48, 48, 49, 75, 80, 53, 90, 77, 48, 56, 86, 83, 89, 90, 67, 89, 67, 89, 57, 52, 75,
      86, 57, 50,
    ],
    privateKey: [76, 106, 111, 65, 50, 75, 65, 80, 77, 105, 100, 74, 98, 109, 70, 79],
    privateIv: [49, 99, 86, 84, 115, 78, 113, 109, 57, 111, 116, 102, 119, 73, 51, 113],
  },
};

const DEFAULT_PRIVATE_KEY_ASCII = [
  97, 97, 118, 100, 101, 99, 49, 54, 100, 102, 121, 50, 48, 49, 57, 106,
];
const DEFAULT_PRIVATE_IV_ASCII = [
  105, 49, 118, 100, 101, 99, 49, 54, 100, 102, 121, 50, 48, 49, 57, 106,
];

function createShuffleIndexes(length) {
  const indexes = Array.from({ length }, (_, index) => index);
  for (let i = indexes.length - 1; i > 0; i--) {
    const j = (i * 7 + 3) % (i + 1);
    [indexes[i], indexes[j]] = [indexes[j], indexes[i]];
  }
  return indexes;
}

function decodeShuffledAscii(shuffledAscii = []) {
  const indexes = createShuffleIndexes(shuffledAscii.length);
  const restoredAscii = new Array(shuffledAscii.length);
  for (let shuffledIndex = 0; shuffledIndex < shuffledAscii.length; shuffledIndex++) {
    const originalIndex = indexes[shuffledIndex];
    restoredAscii[originalIndex] = shuffledAscii[shuffledIndex];
  }
  return String.fromCharCode(...restoredAscii);
}

function decodeSecureKeyItem(value = {}) {
  return {
    keyId: decodeShuffledAscii(value.keyId),
    salt: decodeShuffledAscii(value.salt),
    privateKey: decodeShuffledAscii(value.privateKey),
    privateIv: decodeShuffledAscii(value.privateIv),
  };
}

export function normalizeSecureEnv() {
  const rawEnv = String(process.env.REACT_APP_API || '').toLowerCase();
  switch (rawEnv) {
    case 'production':
    case 'prod':
      return 'prod';
    case 'preview':
    case 'prep':
    case 'pre':
      return 'prep';
    case 'testenv':
    case 'test':
      return 'test';
    case 'local':
    case 'dev':
    default:
      return 'dev';
  }
}

export function getSecureKeyConfig({ useDefault = false } = {}) {
  if (useDefault) {
    return {
      privateKey: decodeShuffledAscii(DEFAULT_PRIVATE_KEY_ASCII),
      privateIv: decodeShuffledAscii(DEFAULT_PRIVATE_IV_ASCII),
    };
  }
  const secureEnv = normalizeSecureEnv();
  return decodeSecureKeyItem(SECURE_KEY_CONFIG_ASCII[secureEnv] || SECURE_KEY_CONFIG_ASCII.dev);
}
